/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* The info about what is in each column in a csv file.
*/
export class Targetjobservicev1Column {
    /**
    * The ID of the Column.
    */
    'id'?: string;
    /**
    * The index of the column in the file. (starts at 0)
    */
    'index'?: number;
    /**
    * The type of column. (ex: ip, address_1, address_2, city, state, zip)
    */
    'type'?: string;
    /**
    * The actual value in the column header.
    */
    'value'?: string;
    /**
    * The ID of the Location this column is associated with.
    */
    'locationId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "index",
            "baseName": "index",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "locationId",
            "baseName": "location_id",
            "type": "string",
            "format": "uuid"
        }    ];

    static getAttributeTypeMap() {
        return Targetjobservicev1Column.attributeTypeMap;
    }

    public constructor() {
    }
}

